import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { useGeoPrice } from '../hooks/useGeoPrice';
export function PromoBanner() {
  const {
    symbol,
    offerPrice,
    originalPrice,
    label
  } = useGeoPrice();
  return <div className="bg-gradient-to-r from-urgency via-red-500 to-urgency relative overflow-hidden" data-id="element-223">
      <div className="relative z-10 max-w-3xl mx-auto px-4 py-4 md:py-5" data-id="element-224">
        {/* Top label */}
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-225">
          <span className="text-[10px] sm:text-xs font-display font-extrabold tracking-[0.2em] uppercase text-yellow-300" data-id="element-226">
            🔥 Super Promo de la Semana 🔥
          </span>
        </div>

        {/* Main message */}
        <p className="text-center text-white font-sans text-sm md:text-base leading-relaxed mb-3 max-w-xl mx-auto" data-id="element-227">
          <strong className="font-display text-yellow-300" data-id="element-228">
            ¡Nos volvimos locos!
          </strong>{' '}
          Hemos bajado los precios de{' '}
          <span className="line-through decoration-white/60 decoration-2 text-white/50" data-id="element-229">
            {symbol}
            {originalPrice} {label}
          </span>{' '}
          a tan solo{' '}
          <span className="font-display font-extrabold text-yellow-300 text-lg md:text-xl" data-id="element-230">
            {symbol}
            {offerPrice} {label}
          </span>
          .{' '}
          <span className="underline decoration-yellow-300 decoration-2 underline-offset-2" data-id="element-231">
            Se acaba pronto
          </span>
          .
        </p>

        {/* CTA button */}
        <div className="flex justify-center" data-id="element-232">
          <a href="#precio" className="inline-flex items-center gap-2 bg-white text-urgency font-display font-extrabold text-sm md:text-base px-6 py-2.5 rounded-xl hover:scale-[1.03] active:scale-[0.97] transition-transform duration-200 shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-233">
            <span data-id="element-234">VER OFERTA</span>
            <ArrowDownIcon className="w-4 h-4" data-id="element-235" />
          </a>
        </div>
      </div>
    </div>;
}